export default __webpack_public_path__ + "static/media/registerImg.79d8fc45.png";